export default __webpack_public_path__ + "static/Plots0090-0252f754de0eb6738f053e40964d1f47.jpg";